// 机构库
const organPool = "/Organization.ashx";
// 省市
const pcapi = "/SignUp.ashx";
// 首页通知公告
const NewsList = "/page.ashx";
//const ZhangBangList = "/SysManageAjaxHandler.ashx";
//首页成果库列表
const ResultList = "/TN/HomeHandler.ashx";

const TypeList = "/SysManage/SysManageAjaxHandler.ashx"; //首页对接动态.
const HostList = "/SysManage/RankingAjaxHandler.ashx";

//揭榜挂帅信息
const ZhangBangList = "/SysManage/SysManageAjaxHandler.ashx";
//揭榜挂帅张榜
//const QzhangBan="/SysManage/SysManageAjaxHandler.ashx"
// const ZhangBangList = '/SysManageAjaxHandler.ashx';
// 云展厅筛选
const cloudSelect = "/ExhibitionHall.ashx";
//云路演接口
const roldList = "/SysManage/SysManageAjaxHandler.ashx";
//云路演图片前缀
  const imgcommonUrl = "http://www.nttzzc.cn";
//  const imgcommonUrl = "http://10.86.12.52:8089";
//收藏、取消收藏
const colect = "/Common.ashx";
// 我要对接-过滤敏感词
const Filter = "/Page.ashx";
// 我要留言对接
const docking = "/UserLeaveMsgHandler.ashx";
const AppealHandle = "/TN/AppealHandle.ashx";
// 加载对接列表 科技活动详情观看人数
const dockingList = "/SysManage/SysManageAjaxHandler.ashx";
// 增加访问量
const addVisitNum = '/Special.ashx'
// export { organPool, pcapi, ZhangBangList, NewsList, TypeList };
// 三个库数据量
const AllDataNum = "TN/DockingLive.ashx";
const PublicityAssuranceHander = "TN/PublicityAssuranceHander.ashx";
// 技术成果库筛选条件
const fruitChoose = "/AchievementsListAjaxHandler.ashx";
// 成果库,登录,注册发送验证码
const library = "/Common.ashx";

// 科技活动
const CollegesHandler = "TN/CollegesHandler.ashx";
// 类型
const science = "/TechnologyActivity.ashx";
//创新人才列表
const InnovativeTalentsHandle = "TN/InnovativeTalentsHandle.ashx";
// 热门专家
const hotperson = "/ExpertsAjaxHandler.ashx";
//人才
const Talent = "/ExpertsAjaxHandler.ashx";
//高校讲堂
const VideoLectureHallHandle = "TN/VideoLectureHallHandle.ashx";
//注册Regist
//注册Regist
const Regist = "/Regist.ashx";
const Register = "/TN/Register.ashx";
const WechatLogin = "/PushAjaxHandler.ashx";
// 需求库筛选
const demandChoose = "/DemandListAjaxHandler.ashx";
// 需求库列表
const demandList = "/TN/DemandHandler.ashx";
const schoolDemandList='/TN/CollegesHandler.ashx'
//对接
const UserLeave = "/UserLeaveMsgHandler.ashx";
const MapData = "/DataStatistics.ashx";
// 通知公告
const Notice = '/NewsAjaxHandler.ashx'
// 对接Docking1   UserLeaveMsgHandler
const Docking1 ='/UserLeaveMsgHandler.ashx'
export {
  schoolDemandList,
  Docking1,
  organPool,
  pcapi,
  ZhangBangList,
  NewsList,
  cloudSelect,
  imgcommonUrl,
  TypeList,
  roldList,
  HostList,
  fruitChoose,
  library,
  ResultList,
  AppealHandle,
  AllDataNum,
  PublicityAssuranceHander,
  hotperson,
  science,
  VideoLectureHallHandle,
  CollegesHandler,
  InnovativeTalentsHandle,
  Talent,
  Register,
  Regist,
  demandChoose,
  demandList,
  colect,
  UserLeave,
  Filter,
  docking,
  dockingList,
  WechatLogin,
  MapData,
  Notice,
  addVisitNum
};